import NotesPanelWrapper from './NotesPanelContainer';

export default NotesPanelWrapper;
